<template>
  <span>
    <router-view></router-view>
    <notifications group="foo" :duration="4000" position='bottom left' class="customNotify" />
    <notifications group="alert" :duration="999999" position='top center'>
      <template slot="body" slot-scope="props">
        <v-dialog v-model="dialog" max-width="600">
          <v-card>
            <v-card-title class="red white--text">{{ props.item.title }}</v-card-title>
            <v-card-text class="pt-2">
              <p style="white-space: pre-line;" v-html="props.item.text"></p>
            </v-card-text>
            <v-card-actions>
              <v-btn text class="notify-close text-center" color="blue darken-3" @click="props.close">متوجه شدم</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </notifications>
  </span>
</template>

<script>
  export default {
    name: 'App',

    data: () => ({
       dialog :true,
    }),
    mounted() {
      var loading = document.getElementById("loading1");
    },
    methods: {
  
    }
  };
</script>

<style>
  @import "./assets/styles/IranSans.css";
  @import "./assets/styles/rtl.scss";
</style>
